/* eslint-disable */
import countryList from '@/data/country';
import stateList from '@/data/state';
import _ from 'lodash';

export default {
  data() {
    return {
      showManualShipmentBlock: false,
      defaultShipmentObject: {
        shippingAgentId: '',
        shippingProductId: '',
        trace_no: '',
        goodsType: 1,
        weight: {
          value: '',
          unit: 'kg',
        },
        dimensions: {
          width: {
            value: '',
            disabled: false,
          },
          height: {
            value: '',
            disabled: false,
          },
          length: {
            value: '',
            disabled: false,
          },
          dimensionsType: 'cm',
        },
      },
      pickupShipments: [
        this.defaultShipmentObject
      ],
      pickupData: {
        pickupDate: '',
        pickupTimeFrom: '',
        pickupTimeUntil: '',
        reference: '',
        company: '',
        attention: '',
        email: '',
        phone: {
          number: '',
          country: '',
        },
      },
      pickupAddress: {
        address_1: '',
        address_2: '',
        post_code: '',
        city: '',
        country_id: '',
        state: '',
      },
    }
  },
  computed: {
    observableObject() {
      return {
        subaccountId: this.get_active_subaccount.id,
        pickupDate: this.pickupData.pickupDate,
        pickupTimeUntil: this.pickupData.pickupTimeUntil,
        pickupTimeFrom: this.pickupData.pickupTimeFrom,
        pickupAddress: this.pickupAddress.address_1,
        pickupCountry: this.pickupAddress.country_id,
        pickupPostcode: this.pickupAddress.post_code,
        pickupCity: this.pickupAddress.city,
        shipments: this.pickupShipments
      };
    },
  },
  methods: {
    makeCall: _.debounce(function(event) {
      this.reloadingProducts = true;
      let payload = {
        subaccount_id: this.get_active_subaccount.id,
        pickup_date: this.pickupData.pickupDate,
        pickup_time_from: this.pickupData.pickupTimeFrom,
        pickup_time_until: this.pickupData.pickupTimeUntil,
        address: this.getRequestFormattedAddress(),
        shipments: this.getRequestFormattedShipments(),
      };

      if (this.isFromViewPage) {
        payload.not_planned_pickup_id = this.$route.params.id
      }

      this.$store.dispatch('GET_AVAILABLE_PICKUP_PRODUCTS', payload).then((res) => {
        if (!res) return;
        this.productsList = res;
        let isProductInList = false;
        this.productsList.forEach((product) => {
          if(product.shipping_product_id == this.selectedProductId) isProductInList = true;
        })
        if(this.selectedProductId != 0 && this.productsList != null && isProductInList){
          this.selectedProduct = this.productsList.filter((product) => Number(product.shipping_product_id) == this.selectedProductId)[0];
        }
        this.reloadingProducts = false;
      });
    }, 500),
    resetShipments() {
      // kad se izmeni toggle hocemo da resetujemo shipmente
      // e sad kako to utice na validacije itd, ako je toggle off ne zelimo da saljemo niti da radimo validaciju za shipmente
      console.log('toggle change');

      this.pickupShipments = [this.defaultShipmentObject]
    },
    selectProduct(val) {
      if((this.selectedProduct != null) && (val.product.id == this.selectedProduct.id) ) {
        this.selectedProduct = null;
        return;
      }
      this.selectedProduct = val.product;
    },
    clearFromFields() {
      this.isForeignPickupLocation = false;
      this.pickupLocationId = null;
      this.cachedPickupLocation = this.pickupLocationId;
      this.clearAddressData('pickup');
    },
    getRequestFormattedAddress() {
      return {
        company_name: this.pickupData.company,
        name: this.pickupData.attention,
        post_code: this.pickupAddress.post_code,
        country_code: this.getCountry(this.pickupAddress.country_id, 'alpha2'),
        country_id: this.pickupAddress.country_id,
        address_1: this.pickupAddress.address_1,
        address_2: this.pickupAddress.address_2,
        city: this.pickupAddress.city,
        phone: this.pickupData.phone.number,
        email: this.pickupData.email,
        state: this.pickupAddress.state
      }
    },
    getRequestFormattedShipments() {
      if (!this.showManualShipmentBlock) return [];
      return this.pickupShipments.map((val) => {
        return {
          shipping_product_id: val.shippingProductId,
          shipping_agent_id: val.shippingAgentId,
          trace_no: val.trace_no,
          goods_type: [val.goodsType],
          colli: [{
            goods_type: val.goodsType,
            weight: val.weight.value,
            weight_type: val.weight.unit,
            height: val.dimensions.height.value,
            length: val.dimensions.length.value,
            width: val.dimensions.width.value,
            dimension_unit: val.dimensions.dimensionsType
          }]
        };
      });
    },
    getCountry: (country_id, prop, fromCALL) => {
      // console.log(`GET "${prop}" of country ${country_id || 'undefined'} and ${fromCALL || 'NOT CALLED FROM REGISTERED CALL'}`)
      return countryList.filter((opt) => opt.id === String(country_id))[0][`${prop}`];
    },
    checkForForeign(val) {
      if (val === null) {
        this.isForeignPickupLocation = true;
        if(!this.isShipperInFrom){
          this.clearAddressData('pickup');
        } else {
          this.clearAddressData('pickup');
          this.cachedPickupLocation = null;
        }
      } else {
        this.isForeignPickupLocation = false;
        const data = this.get_pickup_locations.find((opt) => opt.id === val);
        this.pickupData = {
          ...this.pickupData,
          company: data.company_name || '',
          attention: data.name,
          email: data.email,
          phone: {'number': data.phone, 'country': countryList.filter((opt) => parseInt(opt.id) === parseInt(data.country_id))[0].alpha2},
        };
        this.pickupAddress = {
          address_1: data.address_1,
          address_2: data.address_2,
          city: data.city,
          country_id: data.country_id,
          post_code: data.post_code,
          state: data.state,
        };
      }
    },
    clearAddressData(type) {
      this[`${type}Address`].address_1 = '';
      this[`${type}Address`].address_2 = '';
      this[`${type}Address`].country_id = '';
      this[`${type}Address`].post_code = '';
      this[`${type}Address`].city = '';
      this[`${type}Address`].state = '';

      this[`${type}Data`].company = '';
      this[`${type}Data`].attention = '';
      this[`${type}Data`].email = '';
      this[`${type}Data`].phone = {
        number: '',
        country: '',
      };
    },
    changeAddress(type, val) {
      this[`${type}Address`].address_1 = val.address_1 || '';
      this[`${type}Address`].address_2 = val.address_2 || '';
      this[`${type}Address`].country_id = val.country_id || '';
      this[`${type}Address`].post_code = val.post_code || '';
      this[`${type}Address`].city = val.city || '';

      let flag = false;
      stateList.forEach((state) => {
        if(state.country_name ==  this.getCountry(val.country_id, 'name')){
          flag = true;
        }
      });

      if (flag) {
        this[`${type}Address`].state = val.state;
      } else {
        this[`${type}Address`].state = '';
      }
    },
    openCreatePickupPopup() {
      this.$store.dispatch('GET_SHIPPING_AGENTS');
      this.$store.dispatch('GET_PICKUP_LOCATIONS').then((res) => {
        this.pickupLocationOptions = [
          {value: null, text: 'Other address', country: ''},
          ...res.map((opt) => {
            return {
              value: opt.id,
              country: opt.country_id ? this.getCountry(opt.country_id, 'alpha2') : '',
              text: `
                ${opt.company_name ? opt.company_name + ', ' : ''}
                ${opt.name ? opt.name + ', ' : ''}
                ${opt.address_1 ? opt.address_1 + ', ' : ''}
                ${opt.post_code ? opt.post_code + ', ' : ''}
                ${opt.city ? opt.city + ', ' : ''}
                ${opt.state ? opt.state + ', ' : ''}
                ${opt.country_id ? this.getCountry(opt.country_id, 'name') : ''}
              `
            };
          }),
        ];

        this.showPickupPopup = true;
      });
    },
    popupDataIsValid(validateAddress = true, validateShipment = true) {
      let result = true;
      this.productCardErrorMessage = `${this.$t('validation_message_services')}: </br></br>`
      if(!this.get_active_subaccount.id) {
        this.productCardErrorMessage += `&#x2022; ${this.$t('subaccount_id')}</br>`;
        result = false;
      }
      if(!this.pickupData.pickupDate) {
        this.productCardErrorMessage += `&#x2022; ${this.$t('pickup_date')}</br>`;
        result = false;
      }
      // if(!this.pickupData.pickupTimeUntil) {
      //   this.productCardErrorMessage += `&#x2022; ${this.$t('pickup_time_until')}</br>`;
      //   result = false;
      // }
      if(validateAddress && !this.isAddressInfoValid()) {
        result = false;
      }
      if(validateShipment && !this.isShipmentValid()) {
        result = false;
      }

      this.productCardErrorMessage = this.productCardErrorMessage.replace(/,\s*$/, '');
      this.productCardDataValid = result;
      return result;
    },
    isAddressInfoValid() {
      let result = true;
      if(!this.pickupAddress.post_code) {
        this.productCardErrorMessage += `&#x2022; ${this.$t('pickup_post_code')}</br>`;
        result = false;
      }
      if(!this.pickupAddress.country_id) {
        this.productCardErrorMessage += `&#x2022; ${this.$t('pickup_country_id')}</br>`;
        result = false;
      }
      if(!this.pickupAddress.address_1) {
        this.productCardErrorMessage += `&#x2022; ${this.$t('pickup_address_1')}</br>`;
        result = false;
      }
      if (!this.pickupAddress.city) {
        this.productCardErrorMessage += `&#x2022; ${this.$t('pickup_city')}</br>`;
        result = false;
      }
      return result;
    },
    isShipmentValid() {
      //If toggle is off, we dont wanna validate shipment
      if (!this.showManualShipmentBlock) {
        return true;
      }
      const shipments = this.pickupShipments;
      let result = true;
      if (shipments.length < 1) {
        result = true;
      }

      shipments.forEach((shipment, index) => {
        let shipmentValidation = true;
        let shipmentText = `</br>&#x2022; ${this.$t('shipment')} ${index + 1}: `;
        if(!shipment.weight.value) {shipmentText += `${this.$t('weight')}, `; shipmentValidation = false};
        if(!shipment.weight.unit) {shipmentText += `${this.$t('weight')}, `; shipmentValidation = false};
        if(!shipment.shippingProductId) {shipmentText += `${this.$t('shipping_product_id')}, `; shipmentValidation = false};
        //if(!shipment.goodsType) {shipmentText += `${this.$t('goods_type')}, `; shipmentValidation = false};
        if(!shipment.trace_no) {shipmentText += `${this.$t('awb')}, `; shipmentValidation = false};
        if(!shipment.dimensions.width.value) {shipmentText += `${this.$t('width')}, `; shipmentValidation = false};
        if(!shipment.dimensions.length.value) {shipmentText += `${this.$t('length')}, `; shipmentValidation = false};
        if(!shipment.dimensions.height.value) {shipmentText += `${this.$t('height')}, `; shipmentValidation = false};
        if(!shipment.dimensions.width.value) {shipmentText += `${this.$t('width')}, `; shipmentValidation = false};
        if(!shipment.dimensions.length.value) {shipmentText += `${this.$t('length')}, `; shipmentValidation = false};
        if(!shipment.dimensions.dimensionsType) {shipmentText += `${this.$t('dimension_unit')}, `; shipmentValidation = false};

        if(!shipmentValidation){
          shipmentText = shipmentText.replace(/,\s*$/, '');
          this.productCardErrorMessage += shipmentText;
          result = false;
        }
      });

      return result;
    },
  }
}
